import React from "react";
import classnames from "classnames";
import { NavLink } from "react-router-dom";

// reactstrap components
import {
  Collapse,
  NavbarBrand,
  Navbar,
  NavItem,
  Nav,
  Container
} from "reactstrap";

import { initReactI18next, useTranslation } from "react-i18next";

const OutNavbar = props => {
  const [t, i18n] = useTranslation();
  return <OutNavbar2 {...props} t={t} />;
};

class OutNavbar2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapseOpen: false,
      color: "navbar-transparent"
    };
  }
  componentDidMount() {
    window.addEventListener("resize", this.updateColor);
  }
  // this function opens and closes the collapse on small devices
  // it also adds navbar-transparent class to the navbar when closed
  // ad bg-white when opened
  toggleCollapse = () => {
    let newState = {
      collapseOpen: !this.state.collapseOpen
    };
    if (!this.state.collapseOpen) {
      newState["color"] = "bg-white";
    } else {
      newState["color"] = "navbar-transparent";
    }
    this.setState(newState);
  };
  render() {
    return (
      <Navbar
        className={classnames("navbar-absolute fixed-top", this.state.color)}
        expand="lg"
      >
        <Container>
          <div className="navbar-wrapper">
            <NavbarBrand href="#pablo" onClick={e => e.preventDefault()}>
              {this.props.t("松永興業株式会社")}
            </NavbarBrand>
          </div>
          <button
            aria-controls="navigation-index"
            aria-expanded={false}
            aria-label="Toggle navigation"
            className="navbar-toggler"
            data-toggle="collapse"
            type="button"
            onClick={this.toggleCollapse}
          >
            <span className="navbar-toggler-bar navbar-kebab" />
            <span className="navbar-toggler-bar navbar-kebab" />
            <span className="navbar-toggler-bar navbar-kebab" />
          </button>
          <Collapse
            isOpen={this.state.collapseOpen}
            className="justify-content-end"
            navbar
          >
            <Nav navbar>
              {/* <NavItem>
                <NavLink to="/in/logout" className="nav-link">
                  <i className="nc-icon nc-layout-11" />
                  会員管理
                </NavLink>
              </NavItem> 
              <NavItem>
                <NavLink to="/in/logout" className="nav-link">
                  <i className="nc-icon nc-satisfied" />
                  ぬりえ管理
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink to="/in/logout" className="nav-link">
                  <i className="nc-icon nc-satisfied" />
                  メール管理
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink to="/in/logout" className="nav-link">
                  <i className="nc-icon nc-satisfied" />
                  ログアウト
                </NavLink>
              </NavItem> */}
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
    );
  }
}

export default OutNavbar;
